var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[(_vm.isRender)?_c('div',{class:_vm.$style.block,attrs:{"id":"adv-infinity-feed"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }